import { useTranslations } from 'next-intl';
import Toast from '@/components/ui/Toast/toast';
import { useTimer } from '@/hooks/useTimer';
import { useResendVerificationMutation } from '@/queries/auth/auth.queries';

const RESEND_VERIFICATION_STORAGE_KEY = 'resend_auth_verification_timer';

export const useResendVerification = () => {
  const t = useTranslations('register');
  const { timer: resendTimer, isResendDisabled, restartTimer } = useTimer({ mode: 'countdown', delay: 40, autoStart: false, localStorageKey: RESEND_VERIFICATION_STORAGE_KEY });
  const { mutate: resendVerification, isPending: isResendVerificationPending } = useResendVerificationMutation();

  const handleResendVerification = (email: string) => {
    resendVerification(
      { email },
      {
        onSuccess: () => {
          restartTimer();
          Toast({
            type: 'success',
            title: t('new-verification-email-sent-successfully'),
          });
        },

        onError: () => {
          Toast({
            type: 'error',
            title: t('verification-email-resent-failed'),
          });
        },

      },
    );
  };

  return {
    mutation: {
      isPending: isResendVerificationPending,
      mutate: handleResendVerification,
    },
    timer: {
      count: resendTimer,
      isDisabled: isResendDisabled,
      restartTimer,
    },
  };
};
